import React, { useState, useMemo } from 'react';
import { useLang } from '../../context/LangContext';
import glossaryData from '../../content/learning/glossary.json';
import { getLocalized } from '../../content/learning/getLocalized';

const NAVY  = '#0d1b3e';
const GOLD  = '#c9a23a';
const TEXT  = '#2c2c2c';
const MUTED = '#7a6040';
const BORDER = 'rgba(201,162,58,0.2)';

export default function GlossaryTable() {
  const { t, lang } = useLang();
  const [q, setQ] = useState('');

  const filtered = useMemo(() => {
    if (!q.trim()) return glossaryData;
    const lower = q.toLowerCase();
    return glossaryData.filter(
      (item) =>
        (item[lang] || item.ar || '').includes(q) ||
        (item.en || '').toLowerCase().includes(lower)
    );
  }, [q, lang]);

  const mainLangLabel  = lang === 'en' ? 'English' : lang === 'fa' ? 'فارسی' : 'عربي';
  const secondLangLabel = lang === 'en' ? 'عربي' : 'English';
  const getSecondCol   = (item) => lang === 'en' ? (item.ar || '') : item.en;
  const secondColDir   = lang === 'en' ? 'rtl' : 'ltr';
  const secondColAlign = lang === 'en' ? 'right' : 'left';

  return (
    <div>
      <input
        value={q}
        onChange={(e) => setQ(e.target.value)}
        placeholder={t.learning?.searchPlaceholder}
        style={{
          width: '100%', boxSizing: 'border-box',
          padding: '10px 14px', marginBottom: 16,
          background: '#fff', border: `1px solid ${BORDER}`,
          borderRadius: 8, color: TEXT,
          fontFamily: 'Tajawal, sans-serif', fontSize: 15,
          outline: 'none', transition: 'border-color 0.2s',
        }}
        onFocus={(e) => { e.target.style.borderColor = GOLD; }}
        onBlur={(e)  => { e.target.style.borderColor = BORDER; }}
      />

      <div style={{ overflowX: 'auto' }}>
        <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
          <thead>
            <tr style={{ background: 'rgba(201,162,58,0.1)' }}>
              <th style={{ padding: '10px 14px', textAlign: 'start', color: NAVY, fontWeight: 700, borderBottom: `2px solid ${GOLD}` }}>
                {mainLangLabel}
              </th>
              <th style={{ padding: '10px 14px', textAlign: secondColAlign, color: NAVY, fontWeight: 700, borderBottom: `2px solid ${GOLD}`, direction: secondColDir }}>
                {secondLangLabel}
              </th>
            </tr>
          </thead>
          <tbody>
            {filtered.map((item, i) => (
              <tr
                key={i}
                style={{
                  borderBottom: `1px solid ${BORDER}`,
                  background: i % 2 ? 'rgba(201,162,58,0.04)' : 'transparent',
                  transition: 'background 0.15s',
                }}
                onMouseEnter={(e) => { e.currentTarget.style.background = 'rgba(201,162,58,0.1)'; }}
                onMouseLeave={(e) => { e.currentTarget.style.background = i % 2 ? 'rgba(201,162,58,0.04)' : 'transparent'; }}
              >
                <td style={{ padding: '9px 14px', color: TEXT, fontWeight: 500 }}>
                  {getLocalized(item, lang)}
                </td>
                <td style={{ padding: '9px 14px', color: MUTED, direction: secondColDir, textAlign: secondColAlign }}>
                  {getSecondCol(item)}
                </td>
              </tr>
            ))}
            {filtered.length === 0 && (
              <tr>
                <td colSpan={2} style={{ padding: 28, textAlign: 'center', color: MUTED, fontSize: 14 }}>
                  {t.learning?.noResults}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div style={{ marginTop: 10, fontSize: 12, color: MUTED, textAlign: 'start' }}>
        {filtered.length} / {glossaryData.length}
      </div>
    </div>
  );
}
